export const DEFAULT_API_ERROR_MESSAGE = 'Ei bine, asta e ciudat, ceva nu a mers bine.';

export interface BackendError {
  code?: string;
  errorMessage?: string;
  developerMessage?: string;
  field?: string;
}

export interface BackendErrorResponse {
  message?: string;
  errors?: BackendError[];
}

export class ApiError extends Error {
  status: number;
  errors: BackendError[];
  responseMessage?: string;

  constructor(
    status: number,
    errorData: BackendErrorResponse = {},
    fallbackMessage: string = DEFAULT_API_ERROR_MESSAGE
  ) {
    super(resolveApiErrorMessage(errorData, fallbackMessage));
    this.name = 'ApiError';
    this.status = status;
    this.errors = errorData.errors || [];
    this.responseMessage = errorData.message;
  }

  hasErrorCode(code: string) {
    return this.errors.some(error => error.code === code);
  }

  hasFieldError(field: string) {
    return this.errors.some(error => error.field === field);
  }

  hasDeveloperMessage(message: string) {
    return this.errors.some(error => error.developerMessage === message);
  }
}

export const parseApiErrorResponse = async (response: Response): Promise<BackendErrorResponse> => {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return {};
  }

  return await response.json().catch(() => ({}));
};

export const throwApiError = async (
  response: Response,
  fallbackMessage: string = DEFAULT_API_ERROR_MESSAGE
): Promise<never> => {
  const errorData = await parseApiErrorResponse(response);
  throw new ApiError(response.status, errorData, fallbackMessage);
};

const resolveApiErrorMessage = (
  _errorData: BackendErrorResponse,
  fallbackMessage: string
) => {
  return fallbackMessage;
};
